import React from "react";
import DataTable from "../atoms/DataTable.jsx";
import StatusBadge from "../atoms/StatusBadge.jsx";
import AccountRowActions from "../molecules/AccountRowActions.jsx";

const AccountsTable = ({ accounts, onViewAccount }) => {
  const headers = [
    "Name",
    "ID",
    "Provider",
    "Type",
    "Owner",
    "Status",
    "Actions",
  ];

  const tableData = accounts.map((account) => [
    <span className="font-medium text-gray-900">
      {account.AccountName || "No name"}
    </span>,
    <code className="text-sm bg-gray-100 px-2 py-1 rounded font-mono">
      {account.AccountId || "N/A"}
    </code>,
    <span className="text-gray-600">{account.CloudProvider || "N/A"}</span>,
    <span className="text-gray-600">{account.Type || "N/A"}</span>,
    <span className="text-gray-600">{account.AccountOwner || "N/A"}</span>,
    <StatusBadge active={!account.Decommissioned} />,
    <AccountRowActions onView={() => onViewAccount(account)} />,
  ]);

  const emptyMessage = "No accounts available";

  return (
    <DataTable 
      headers={headers} 
      data={tableData} 
      emptyMessage={emptyMessage} 
    />
  );
};

export default AccountsTable;
